import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import React from "react";
import { useState } from 'react';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { yellow } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { PendingActionsOutlined } from '@mui/icons-material';
import image from "../../Assets/img/logo-small.png"

{/*
College Profile
Created on 26/3/2024
*/}
export default function Profile() {
    const navigate = useNavigate();
    const isAuth = useAuth();
    if (isAuth === false) {
        navigate("/admin/")
    }



    const [activeTab, setActiveTab] = useState(1);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    const [disabled, setDisabled] = useState(false); // State to determine disabled status


    const [collegeinfo, setCollegeInfo] = useState([]);
    const [collegeauthority, setCollegeAuthority] = useState([]);
    const [collegenaac, setCollegeNaac] = useState([]);



    const [isAccess, setAccess] = useState({
        viewCollege: false

    });

    const open = () => {
        setDisabled(previous => !previous);
    }


    useEffect(() => {
        const access = async () => {
            const { http } = Api();
            const id = localStorage.getItem("id");
            try {
                const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });
                const permissions = response.data.map(permission => permission.name);

                const hasViewCollgePermission = permissions.includes("view-college");

                setAccess({
                    viewCollege: hasViewCollgePermission
                });
            } catch (error) {
                console.error("Error fetching user roles:", error);
            }
        };
        access();
    }, []);


    useEffect(() => {
        fetchCollegeInfo();
        fetchCollegeAuthority();
        fetchCollegeNaac();
    }, []);

    const fetchCollegeInfo = async () => {
        try {

            const { http } = Api();
            const response = await http.get(`/Admin/getcollege`);
            if (response.data.status_code === "ERR5") {
                console.log("no data found")
            }
            else {
                setCollegeInfo(response.data.college_name);
            }



        } catch (error) {
            console.error('Error fetching user log data:', error);

        }
    };

    const fetchCollegeAuthority = async () => {
        try {
            const collegeid = localStorage.getItem("collegeid");
            const { http } = Api();
            const response = await http.get(`/Admin/getcollegeauthorities`);
            if (response.data.status_code === "ERR5") {
                console.log("no data found")
            }
            else {
                setCollegeAuthority(response.data.college_name);
            }
            //console.log(response.data.college_name);


        } catch (error) {
            console.error('Error fetching user log data:', error);

        }
    };

    const fetchCollegeNaac = async () => {
        try {
            const collegeid = localStorage.getItem("collegeid");
            const { http } = Api();
            const response = await http.get(`/Admin/getcollegenaac`);
            if (response.data.status_code === "ERR5") {
                console.log("no data found")
            }
            else {
                setCollegeNaac(response.data.college_name);
            }
            // console.log(response);


        } catch (error) {
            console.error('Error fetching user log data:', error);

        }
    };

    const getCycle = (num) => {
        switch (num) {
            case "1":
                return "1st";
            case "2":
                return "2nd";
            case "3":
                return "3rd";
            case "4":
                return "4th";
            default:
                return num; // If cycle is none of 1, 2, 3, or 4, return the original value
        }
    };


    return (
        <>

            <Template>
                <div class="container-fluid">
                    <div class="email-wrap bookmark-wrap">
                        <div class="row">
                            <div class="col-xl-3 box-col-6">
                                <div class="md-sidebar"><a class="btn btn-primary md-sidebar-toggle" onClick={open}>PROFILE MENU</a>
                                    <div class={`md-sidebar-aside job-left-aside custom-scrollbar ${disabled && "open"}`} >
                                        <div class="email-left-aside">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="email-app-sidebar left-bookmark">
                                                        <div class="media">
                                                            <div class="media-size-email"><img class="me-3 rounded-circle" src="../assets/images/user/user.png" alt="" /></div>
                                                            <div class="media-body d-flex align-items-center">

                                                                <h6 class="f-w-600 mb-0">PROFILE MENU</h6>
                                                            </div>

                                                        </div>
                                                        <ul class="nav main-menu" role="tablist" style={{ cursor: "pointer" }}>
                                                            <li>
                                                                <hr />
                                                            </li>
                                                            <li class="nav-item"><span class="main-title"></span></li>
                                                            <li><a className={activeTab === 1 ? "bg-primary  " : ""} id="pills-created-tab" data-bs-toggle="pill" onClick={() => handleTabChange(1)} role="tab" aria-controls="pills-created" aria-selected="true" ><span className={activeTab === 1 ? "title active  " : "title"} >College info</span></a></li>
                                                            <li><a className={activeTab === 2 ? "bg-primary  " : ""} id="pills-created-tab" data-bs-toggle="pill" onClick={() => handleTabChange(2)} role="tab" aria-controls="pills-created" aria-selected="true"><span className={activeTab === 2 ? "title active  " : "title"}>Principal</span></a></li>
                                                            <li><a className={activeTab === 3 ? "bg-primary " : ""} id="pills-favourites-tab" data-bs-toggle="pill" role="tab" onClick={() => handleTabChange(3)} aria-controls="pills-favourites" aria-selected="false"><span className={activeTab === 3 ? "title active  " : "title"}>Admission Officer</span></a></li>
                                                            <li><a className={activeTab === 4 ? "bg-primary " : ""} id="pills-shared-tab" data-bs-toggle="pill" role="tab" onClick={() => handleTabChange(4)} aria-controls="pills-shared" aria-selected="false"><span className={activeTab === 4 ? "title active  " : "title"}> FYUGP Nodal Officer</span></a></li>
                                                            <li><a className={activeTab === 5 ? "bg-primary " : ""} id="pills-bookmark-tab" data-bs-toggle="pill" role="tab" onClick={() => handleTabChange(5)} aria-controls="pills-bookmark" aria-selected="false"><span className={activeTab === 5 ? "title active  " : "title"} >Accreditation</span></a></li>
                                                            <li>
                                                                <hr />
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {isAccess.viewCollege ? (
                                <div class="col-xl-9 col-md-12 box-col-12">
                                    <div class="email-right-aside bookmark-tabcontent">
                                        <div class="card email-body radius-left">
                                            <div class="ps-0">
                                                <div >




                                                    {activeTab === 1 && (

                                                        <div class="tab-pane fade active show" id="pills-created" role="tabpanel" aria-labelledby="pills-created-tab">
                                                            <div class="card mb-0">

                                                                <div class="card-body pb-0">
                                                                    <div class="details-bookmark text-center">
                                                                        <div class="row" id="bookmarkData">

                                                                            <div className="col-xxl-12 col-xl-12 col-sm-12 box-col-12 d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
                                                                                <div className="card purchase-card discover h-100 w-100  ms-3 m-r-15" style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)' }}>
                                                                                    <img
                                                                                        className="img-fluid object-fit-cover"
                                                                                        src={image}
                                                                                        alt="vector discover"
                                                                                        style={{ width: "100px" }}
                                                                                    />
                                                                                    <div className="card-body h-100 d-flex flex-column justify-content-between" >
                                                                                        <div>
                                                                                            <h5 className="mb-3 font-weight-bold">{localStorage.getItem('username')}</h5>
                                                                                            <p className="mb-2">
                                                                                                <i className="fas fa-globe me-2"></i>
                                                                                                <a href={`https://${collegeinfo.college_web}`} className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                                                                                                    {collegeinfo.college_web}
                                                                                                </a>
                                                                                            </p>
                                                                                            <p className="mb-2">
                                                                                                <i className="fas fa-envelope me-2"></i>
                                                                                                <a href={`mailto:${collegeinfo.college_email}`} className="text-decoration-none">
                                                                                                    {collegeinfo.college_email}
                                                                                                </a>
                                                                                            </p>
                                                                                            <p className="mb-2">
                                                                                                <i className="fas fa-phone me-2"></i>
                                                                                                <a href={`tel:${collegeinfo.college_contact_no}`} className="text-decoration-none">
                                                                                                    {collegeinfo.college_contact_no}
                                                                                                </a>
                                                                                            </p>
                                                                                            <p className="mb-4">
                                                                                                <i className="fas fa-map-marker-alt me-2"></i>
                                                                                                {collegeinfo.college_address}
                                                                                            </p>

                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>





                                                    )}

                                                    {activeTab === 2 && (


                                                        <div class="tab-pane fade active show" id="pills-created" role="tabpanel" aria-labelledby="pills-created-tab">
                                                            <div class="card mb-0">
                                                                <div class="card-header d-flex">
                                                                    <h6 class="mb-0"><b>Principal</b></h6>
                                                                    <ul>
                                                                        <li><a class="grid-bookmark-view" href="javascript:void(0)"><i data-feather="grid"></i></a></li>
                                                                        <li><a class="list-layout-view" href="javascript:void(0)"><i data-feather="list"></i></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="card-body pb-0">
                                                                    <div class="details-bookmark text-center">
                                                                        <div class="row" id="bookmarkData">

                                                                            <div class="row">
                                                                                <div class="col-md-6">
                                                                                    <div class="card border-0" style={{ height: "100%", marginBottom: "0px" }}>
                                                                                        <div class="border_2px bg-primary text-white" style={{ borderRadius: "2px !important" }} >
                                                                                            <div class="d-flex align-items-center">
                                                                                                <i class="fas fa-user-tie me-2"></i>
                                                                                                <h6 class="mb-0 text-uppercase">Principal</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="card-body p-4 d-flex flex-column">
                                                                                            <p class="text-start "><span className='fw-bold text-success'>Name:</span> {collegeauthority.principal_name}</p>

                                                                                            <p class="text-start"><span className='fw-bold text-success'>Official Mobile No:</span> {collegeauthority.principal_officenumber}</p>
                                                                                            <p class="text-start"><span className='fw-bold text-success'>Address:</span> {collegeauthority.principal_address}</p>
                                                                                            <p class="text-start"><span className='fw-bold text-success'>Official Email:</span> {collegeauthority.principal_email_office}	</p>
                                                                                            <p class="text-start"><span className='fw-bold text-success'>QP Delivery Email:</span> {collegeauthority.principal_email_for_qp}	</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="card border-0" style={{ height: "100%", marginBottom: "0px" }}>
                                                                                        <div class="border_2px bg-secondary text-white" style={{ borderRadius: "2px" }}>
                                                                                            <div class="d-flex align-items-center">
                                                                                                <i class="fas fa-user-tie me-2"></i>
                                                                                                <h6 class="mb-0 text-uppercase">Vice Principal</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="card-body p-4 d-flex flex-column">
                                                                                            <p class="text-start"><span class="fw-bold text-success">Name:</span>{collegeauthority.viceprincipal_name}</p>

                                                                                            <p class="text-start"><span class="fw-bold text-success">Official Mobile No:</span>{collegeauthority.viceprincipal_mobilenumber}</p>
                                                                                            <p class="text-start"><span class="fw-bold text-success">Official Email:</span>{collegeauthority.viceprincipal_email}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )}

                                                    {activeTab === 3 && (


                                                        <div class="tab-pane fade active show" id="pills-created" role="tabpanel" aria-labelledby="pills-created-tab">
                                                            <div class="card mb-0">
                                                                <div class="card-header d-flex">
                                                                    <h6 class="mb-0"><b>Admission Officer</b></h6>
                                                                    <ul>
                                                                        <li><a class="grid-bookmark-view" href="javascript:void(0)"><i data-feather="grid"></i></a></li>
                                                                        <li><a class="list-layout-view" href="javascript:void(0)"><i data-feather="list"></i></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="card-body pb-0">
                                                                    <div class="details-bookmark text-center">
                                                                        <div class="row" id="bookmarkData">


                                                                            <div class="col-md-12">
                                                                                <div class="card border-0" style={{ height: "100%", marginBottom: "0px" }}>
                                                                                    <div class="border_2px bg-primary text-white" style={{ borderRadius: "2px !important" }} >
                                                                                        <div class="d-flex align-items-center">
                                                                                            <i class="fas fa-user-tie me-2"></i>
                                                                                            <h6 class="mb-0 text-uppercase">Admission Nodal Officer</h6>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="card-body p-4 d-flex flex-column">
                                                                                        <p class="text-start "><span className='fw-bold text-success'>Name:</span>  {collegeauthority.admission_officer4_name}</p>
                                                                                        <p class="text-start"><span className='fw-bold text-success'>Official Email:</span>{collegeauthority.admission_officer4_email}	</p>
                                                                                        <p class="text-start"><span className='fw-bold text-success'>Official Mobile No:</span> {collegeauthority.admission_officer4_mobile}</p>


                                                                                    </div>
                                                                                </div>
                                                                            </div>




                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )}

                                                    {activeTab === 4 && (


                                                        <div class="tab-pane fade active show" id="pills-created" role="tabpanel" aria-labelledby="pills-created-tab">
                                                            <div class="card mb-0">
                                                                <div class="card-header d-flex">
                                                                    <h6 class="mb-0"><b>FYUGP Nodal Officer</b></h6>
                                                                    <ul>
                                                                        <li><a class="grid-bookmark-view" href="javascript:void(0)"><i data-feather="grid"></i></a></li>
                                                                        <li><a class="list-layout-view" href="javascript:void(0)"><i data-feather="list"></i></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="card-body pb-0">
                                                                    <div class="details-bookmark text-center">
                                                                        <div class="row" id="bookmarkData">


                                                                            <div class="col-md-12">
                                                                                <div class="card border-0" style={{ height: "100%", marginBottom: "0px" }}>
                                                                                    <div class="border_2px bg-primary text-white" style={{ borderRadius: "2px !important" }} >
                                                                                        <div class="d-flex align-items-center">
                                                                                            <i class="fas fa-user-tie me-2"></i>
                                                                                            <h6 class="mb-0 text-uppercase">FYUGP Nodal Officer</h6>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="card-body p-4 d-flex flex-column">
                                                                                        <p class="text-start "><span className='fw-bold text-success'>Name:</span>  {collegeauthority.fyugp_coordinator}</p>
                                                                                        <p class="text-start"><span className='fw-bold text-success'>Official Email:</span>{collegeauthority.fyugp_coordinator_email}	</p>
                                                                                        <p class="text-start"><span className='fw-bold text-success'>Official Mobile No:</span> {collegeauthority.fyugp_coordinator_mob}</p>
                                                                                        <p class="text-start"><span className='fw-bold text-success'>WhatsApp No:</span>{collegeauthority.fyugp_coordinator_whatsapp}	</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>




                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )}

                                                    {activeTab === 5 && (


                                                        <div class="tab-pane fade active show" id="pills-created" role="tabpanel" aria-labelledby="pills-created-tab">
                                                            <div class="card mb-0">
                                                                <div class="card-header d-flex">
                                                                    <h6 class="mb-0"><b>Accreditation</b></h6>
                                                                    <ul>
                                                                        <li><a class="grid-bookmark-view" href="javascript:void(0)"><i data-feather="grid"></i></a></li>
                                                                        <li><a class="list-layout-view" href="javascript:void(0)"><i data-feather="list"></i></a></li>
                                                                    </ul>
                                                                </div>
                                                                <div class="card-body pb-0">
                                                                    <div class="details-bookmark text-center">
                                                                        <div class="row" id="bookmarkData">


                                                                            <div class="col-md-12 ">


                                                                                <div className="card purchase-card discover w-100 d-flex justify-content-center align-items-center" style={{ boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)' }}>
                                                                                    <img
                                                                                        className="img-fluid object-fit-cover"
                                                                                        src={image}
                                                                                        alt="vector discover"
                                                                                        style={{ width: "100px" }}
                                                                                    />
                                                                                    <div className="card-body h-100 d-flex flex-column justify-content-between" >
                                                                                        <div>
                                                                                            <h5 className="mb-3 font-weight-bold">{localStorage.getItem('username')}</h5>
                                                                                            <div align="">
                                                                                                {collegenaac.accreditation ? (
                                                                                                    <>

                                                                                                        <i className="fa fa-university m-r-5 m-b-10" style={{ color: 'green' }}></i>
                                                                                                        {collegenaac.accreditation === 1 && (
                                                                                                            <span>
                                                                                                                Accredited with {collegenaac.grade} Grade (CGPA-{collegenaac.cgpa}) - {collegenaac.year}
                                                                                                            </span>
                                                                                                        )}
                                                                                                        {collegenaac.accreditation === 2 && (
                                                                                                            <span>
                                                                                                                Re-accredited with {collegenaac.grade} Grade (CGPA-{collegenaac.cgpa}) in {getCycle(collegenaac.cycle)} Cycle - {collegenaac.year}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <div className="table-responsive">
                                                                                                        <p className="txt-aln">No Data Available..</p>
                                                                                                    </div>
                                                                                                )}
                                                                                                <br />
                                                                                                {collegenaac.nirf_rank && (
                                                                                                    <>
                                                                                                        <i className="fa fa-certificate" style={{ color: '#fcc200' }}></i>
                                                                                                        #{collegenaac.nirf_rank} Rank in NIRF({collegenaac.nirf_year})
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>




                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    )}





                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div class="col-xl-9 col-md-12 box-col-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="email-app-sidebar left-bookmark">
                                                <div class="card-body d-flex justify-content-center align-items-center">
                                                    <div class="card-body pdg1">
                                                        <div class="table-responsive text-center">
                                                            <h4>You don't have access to view this details</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            )}
                        </div>
                    </div>
                </div>

            </Template >
        </>
    )
}
